import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react'
import { Col } from 'reactstrap';
import Config from '../../../../Config';
import Checkbox from '../../../Shared/CheckBox/Checkbox';
import { connect } from 'react-redux';
import { addAddonToPackage } from '../../CellcomAbroadLobbyBlock/Shared/abroadThunk';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { formatDatesToDifferentFormats, getPackageEndDate } from '../../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';
import lodash from 'lodash';
import Loader from '../../../Shared/LocalLoader/LocalLoader';
import { dwhAbroadAddonsSuccessPage, dwhAbroadAddonsPopup } from '../../CellcomAbroadLobbyBlock/dwhReports'
import { prepareUrl } from '../../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import { gaOrderAddon } from '../gaReports'
import Addons from '../../AddonsBlock/Addons';
import { AbroadSocType, AddonType } from '../../CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';
function AddonTicketPopup(props) {

  const [isChecked, setIsChecked] = useState(false)
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  // Add-ons of package- from epi
  let currentAddonToShow = props.addonToShow;
  const params = {
    channel: props.activeLobbyTab && props.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1: props.isJETAuthentication ? 'JET' : 'WEBSITE',
    param2: currentAddonToShow.socCode,
    param3: props.selectedAbroadPackage?.isFamilyBonus ? 'בני משפחות' : props.epiStyleInitializationData.businessIndividualLobby ? 'Individual' : '',
    param4: props.userData?.contactNumber,
    param5: props.countriesCode?.map(c => c.countryCode).join(','),
    costumerName: props.userData?.firstName + ' ' + props.userData?.lastName,
    idNumber: props.userData?.IDNumber,
    subscriber: props.subscriber,
  }

  String.prototype.isNumberPrice = function () { return /^\d+(\.\d+)?$/.test(this); }

  const purchaseAddon = async () => {
    dwhAbroadAddonsSuccessPage({ message: 'Addon PopUp Purchase Button Clicked', ...params });
    const startDate = props.addonToShow.startDate;
    const customerData = {
      subscriberNumber: props.subscriber,
      soc: currentAddonToShow.socCode,
      startDate: startDate,
      countries: lodash.map(props.data.selectedCountries, 'countryCode'),
      accountType: props.data.otpData.validatedCostumerData?.accountType,
      addonType: currentAddonToShow.type,
      parentSocCode: props.data.selectedAbroadPackage.socCode,
      blockId: props.data.epiStyleInitializationData.addonsPackagesFolderId
    };
    gaOrderAddon();
    await props.addAddonToPackage(customerData).then((res) => {
      if (res.payload?.Body.isSuccess) {       
        dwhAbroadAddonsPopup({ message: 'Success', status: 'Completed', ...params })
      }
      else {
        dwhAbroadAddonsPopup({ message: 'General Error', status: 'Error', ...params })
      }
      props.closePopup();
    });
  }

  return (

    <Col className='addon-popup'>
      <Image className="top-img" src={Config.epiBaseUrl + currentAddonToShow.icon} />
      <span className="title">{currentAddonToShow.title}</span>
      <span className="description">{currentAddonToShow.description}</span>

      <div className="price-frame">
        <span className="addon-text font-weight-bold">{currentAddonToShow.packageName}</span>
        <>
          {
            (currentAddonToShow.price).isNumberPrice() ?
              <div className="price">
                <span>{currentAddonToShow.price} ₪</span>
                <span> חד פעמי </span>
              </div>
              :
              <span>{currentAddonToShow.price} </span>

          }
        </>
      </div>
      <div className="term-condition">
        <Checkbox
          id='terms-checkbox'
          onCheck={() => setIsChecked(true)}
          onUncheck={() => setIsChecked(false)}
          checked={isChecked}>
          <span> אני מאשר\ת את </span>
          <a className='term-link' href='#' onClick={() => prepareUrl(currentAddonToShow.pdfAgreementForPackage, EpiContext)}> תנאי השימוש  </a>
        </Checkbox>
      </div>
      {showErrorMessage && !isChecked &&
        <p className='checkbox-error-msg mt-3'>אנא אשר את תנאי השימוש ועקרי ההסכם</p>
      }
      <BtnSubmit text={'לרכישה'} onclick={() => { isChecked ? purchaseAddon() : setShowErrorMessage(true) }} />

      {props.data.isLoading && <Loader />}
    </Col>
  )
}
const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    isJETAuthentication: state.cellcomAbroad.isJETAuthentication,
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    selectedAbroadPackage: state.cellcomAbroad.selectedAbroadPackage,
    epiStyleInitializationData: state.cellcomAbroad.epiStyleInitializationData,
    contactSubscriberNumber: state.authentication.loginData.userDetails.contactNumber,
    subscriber: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
      ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
      : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
    countriesCode: state.cellcomAbroad.selectedCountries,
    userData: state.authentication?.loginData?.userDetails,
    showAddonPopup: state.cellcomAbroad.showAddonPopup,
    selectedSubscriber: state.selfcarePage.selectedSubscriber
  }

};
const mapDispatchToProps = {
  addAddonToPackage
};

export default connect(mapStateToProps, mapDispatchToProps)(AddonTicketPopup);
